/**
 * @generated SignedSource<<f3909771eef730f194dc61947020ceb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Action__CancelHoldPayload",
    "kind": "LinkedField",
    "name": "actionCancelHold",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Entity",
        "kind": "LinkedField",
        "name": "entity",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availability",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityState",
            "kind": "LinkedField",
            "name": "entityStates",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionCancelHoldMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionCancelHoldMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "54d54110023dd50187e8db6e5b56a28f",
    "id": null,
    "metadata": {},
    "name": "ActionCancelHoldMutation",
    "operationKind": "mutation",
    "text": "mutation ActionCancelHoldMutation(\n  $input: Action__CancelHoldInput!\n) {\n  actionCancelHold(input: $input) {\n    entity {\n      id\n      dbId\n      availability\n      entityStates {\n        id\n        dbId\n        state\n        dueDate\n        userId\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

node.hash = "f931ba3ff632f375e3cbf817489f73e7";

module.exports = node;
